import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const ComponentElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Custom Component',
  icon: 'MenuAlt3Icon',
  description: 'Adds a custom component to the page',
  properties: [
    'layout',
    {
      label: 'Component Name',
      name: 'componentName',
      editor: 'textbox',
      default: '',
      description: 'The name of the custom component',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Title',
      name: 'text',
      editor: 'textbox',
      default: '',
      description: 'The title to pass along to the component',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'margin',
    'padding'
  ]
};

export default ComponentElementFields;
